import {FormationResultComponent} from "../components/resultats/formation-result/formation-result.component";
import {RessourcesResultComponent} from "../components/resultats/ressources-result/ressources-result.component";
import {CatalogueResultComponent} from "../components/resultats/catalogue-result/catalogue-result.component";


export function getClassName(component: string) {
  switch (component) {
    case 'ressources':
      return RessourcesResultComponent
    case 'catalogue':
      return CatalogueResultComponent
    case 'module':
      return CatalogueResultComponent
    default:
      console.error("Unknown component View")
      // this is empty components we don't use it
      return FormationResultComponent;
  }
}
